import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { adminForgotPassword, adminLogin } from "../src/services/Api.jsx";
import { useNavigate } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import loginImg from './Images/login-img.svg';
import half from './Images/half.png';
import showPass from './Images/eye-slash.svg'
import hidePass from './Images/eye.svg'

function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const isLoggedIn = localStorage.getItem('isLoggedIn');

  // Redirect to dashboard if already logged in


  useEffect(() => {
    if (isLoggedIn) {
      navigate('/admin/dashboard');
    }
  }, [isLoggedIn, navigate]);

  console.log(isLoggedIn);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),

    password: Yup.string().when('forgotPassword', (forgotPassword, schema) => {
      return forgotPassword
        ? schema.notRequired()
        : schema
          .min(6, 'Password must be at least 6 characters')
          .required('Password is required');
    }),

    forgotPassword: Yup.boolean()
  });


  const handleSubmit = (values, { setSubmitting }) => {
    const { email, password } = values;

    if (forgotPassword) {
      adminForgotPassword(email)
        .then((res) => {
          toast(res?.data?.message);
          setForgotPassword(false)
        })
        .catch((err) => {
          toast(err.response?.data?.message);
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
    else {
      adminLogin(email, password)
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('isLoggedIn', true);
            navigate('/admin/dashboard');
          } else {
            throw new Error('Request failed');
          }
        })
        .catch((err) => {
          toast(err.response?.data?.message || 'Something went wrong');
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="block lg:flex min-h-screen md:mx-28 md:px-14 sm:mx-14 sm:px-10 mx-5 px-5">
        <div className="w-full lg:w-1/2 flex px-8 sm:px-12 lg:px-16">
          <div className="w-full h-full">
            <div className="right-10 top-20 relative">
              <img className="h-24" alt="half" src={half} />
            </div>
            {forgotPassword ?
              <div>
                <h2 className="text-3xl font-semibold text-[#192326]">Forgot Password</h2>
                <p className="mt-2 text-base text-[#747474] my-5">Please Enter your account email so we can send you Password details</p>
              </div>
              :
              <div>
                <h2 className="text-4xl font-semibold text-[#192326]">Login</h2>
                <p className="mt-2 text-md text-[#747474] my-5">Welcome to the urbancabpartner</p>
              </div>
            }
            <Formik
              initialValues={{
                email: '',
                password: '',
                forgotPassword
              }}
              enableReinitialize
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, setFieldValue }) => (
                <Form className="space-y-4">
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-[#192326]">
                      Email Id
                    </label>
                    <Field
                      id="email"
                      name="email"
                      type="email"
                      placeholder="Enter Email"
                      className="mt-1 border-2 w-full outline-none ps-3 rounded-md h-9"
                    />
                    <ErrorMessage name="email" component="div" className="text-red-600 text-sm" />
                  </div>
                  {!forgotPassword &&
                    <div>
                      <label htmlFor="password" className="block text-sm font-semibold text-[#192326]">
                        Password
                      </label>
                      <div className="relative">
                        <Field
                          id="password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter Password"
                          className="mt-1 border-2 w-full outline-none ps-3 rounded-md h-9"
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="absolute right-3 top-3 text-gray-400 hover:text-gray-300"
                        >
                          {showPassword ? (
                            <img alt='showPass' src={showPass} />
                          ) : (
                            <img alt='hidePass' src={hidePass} />
                          )}
                        </button>
                      </div>
                      <ErrorMessage name="password" component="div" className="text-red-600 text-sm" />
                    </div>
                  }
                  <div className="flex items-center justify-end my-5">
                    <div className="text-sm">
                      {forgotPassword ?
                        <button type='button' className="font-medium text-gray-600 hover:text-blue-500" onClick={() => { setFieldValue('forgotPassword', false); setForgotPassword(false) }} >
                          Go Back to Login Page
                        </button>
                        :
                        <button type='button' className="font-medium text-red-600 hover:text-red-500" onClick={() => { setFieldValue('forgotPassword', true); setForgotPassword(true) }}>
                          Forgot Password?
                        </button>
                      }
                    </div>
                  </div>
                  <div>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full bg-[#E53935] hover:bg-red-600 text-white font-semibold rounded-md h-9"
                    >
                      {isSubmitting ? forgotPassword ? 'Updating...' : 'Logging in...' : forgotPassword ? 'Update Password' : 'Login'}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <div className="w-full lg:w-1/2 h-screen mt-5 lg:mt-0 bg-[url('./Images/login-image.svg')] bg-cover bg-center bg-no-repeat">
          <img className="h-full w-full scale-x-[-1]" alt="car" src={loginImg} />
        </div>
      </div>
    </>
  );
}

export default Login;






// import React, { useEffect, useState } from 'react';
// import { ToastContainer, toast } from 'react-toastify';
// import { adminSendOTP, adminVerifyOTP } from "../src/services/Api.jsx";
// import { useNavigate } from 'react-router-dom';
// import loginImg from './Images/login-img.svg';
// import half from './Images/half.png';

// function Login() {
//   const navigate = useNavigate();
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [enterOTP, setEnterOTP] = useState(false);
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState('');
  
//   const isLoggedIn = localStorage.getItem('isLoggedIn');

//   useEffect(() => {
//     if (isLoggedIn) {
//       navigate('/admin/dashboard');
//     }
//   }, [isLoggedIn, navigate]);

//   // Send OTP
//   const handleSendOTP = () => {
//     if (!email) {
//       toast("Please Enter a valid Email");
//       return;
//     }

//     setIsSubmitting(true);
//     adminSendOTP(email)
//       .then((res) => {
//         toast(res?.data?.message);
//         setEnterOTP(true);
//       })
//       .catch((err) => {
//         console.error(err);
//         toast(err.response?.data?.error || "Failed to send OTP");
//       })
//       .finally(() => {
//         setIsSubmitting(false);
//       });
//   };

//   // Verify OTP
//   const handleVerifyOTP = () => {
//     if (!otp) {
//       toast("Please Enter OTP");
//       return;
//     }

//     adminVerifyOTP(email, otp)
//       .then((res) => {
//         toast(res?.data?.message);
//         localStorage.setItem('token', res.data.token);
//         localStorage.setItem("isLoggedIn", true);
//         navigate('/admin/dashboard');
//       })
//       .catch((err) => {
//         toast(err.response?.data?.message || "Invalid OTP");
//       });
//   };

//   return (
//     <>
//       <ToastContainer />
//       <div className="block lg:flex min-h-screen md:mx-28 md:px-14 sm:mx-14 sm:px-10 mx-5 px-5">
        
//         {/* Left Section */}
//         <div className="w-full lg:w-1/2 flex px-8 sm:px-12 lg:px-16">
//           <div className="w-full h-full">
//             <div className="right-10 top-20 relative">
//               <img className="h-24" alt="half" src={half} />
//             </div>

//             {/* Title */}
//             <div>
//               <h2 className="text-4xl font-semibold text-[#192326]">
//                 {enterOTP ? "Login OTP" : "Login"}
//               </h2>
//               <p className="mt-2 text-md text-[#747474] my-5">
//                 Welcome to the urbancabpartner
//               </p>
//             </div>

//             {/* Form */}
//             <div className='my-10'>
//               {enterOTP ? (
//                 <>
//                   <label htmlFor="otp" className="block text-sm font-semibold text-[#192326]">
//                     OTP
//                   </label>
//                   <input
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                     id="otp"
//                     name="otp"
//                     type="password"
//                     placeholder="Enter OTP"
//                     className="mt-1 border-2 w-full outline-none ps-3 rounded-md h-9"
//                   />
//                 </>
//               ) : (
//                 <>
//                   <label htmlFor="email" className="block text-sm font-semibold text-[#192326]">
//                     Email Id
//                   </label>
//                   <input
//                     onChange={(e) => setEmail(e.target.value)}
//                     value={email}
//                     id="email"
//                     name="email"
//                     type="email"
//                     placeholder="Enter Email"
//                     className="mt-1 border-2 w-full outline-none ps-3 rounded-md h-9"
//                   />
//                 </>
//               )}
//             </div>

//             {/* Button */}
//             <div>
//               {enterOTP ? (
//                 <button
//                   type="submit"
//                   onClick={handleVerifyOTP}
//                   className="w-full bg-[#E53935] hover:bg-red-600 text-white font-semibold rounded-md h-9"
//                 >
//                   Verify OTP
//                 </button>
//               ) : (
//                 <button
//                   type="submit"
//                   disabled={isSubmitting}
//                   onClick={handleSendOTP}
//                   className="w-full bg-[#E53935] hover:bg-red-600 text-white font-semibold rounded-md h-9"
//                 >
//                   {isSubmitting ? 'Sending ...' : 'Send OTP'}
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Right Section */}
//         <div className="w-full lg:w-1/2 h-screen mt-5 lg:mt-0 bg-[url('./Images/login-image.svg')] bg-cover bg-center bg-no-repeat">
//           <img className="h-full w-full scale-x-[-1]" alt="car" src={loginImg} />
//         </div>
//       </div>
//     </>
//   );
// }

// export default Login;
